(function (pmw, $, undefined) {

	const PMW_LIBRARY_VERSION = "1.59.0"

	pmw.getLibraryVersion = () => {
		return PMW_LIBRARY_VERSION
	}

	pmw.checkLibraryVersion = () => {

		if (pmw.getLibraryVersion() !== pmwDataLayer?.version?.number) {
			console.error(`Pixel Manager: The library version ${pmw.getLibraryVersion()} and pmwDataLayer.version.number ${pmwDataLayer.version.number} do not match. Delete the server-side cache and try again.`)
		}
	}

}(window.pmw = window.pmw || {}, jQuery))

